<template lang="pug">
a.report-button.--base-color.--underline-effect(
  @click="showReportModal"
) report
</template>

<script>
import { mapActions } from 'vuex'
import { $modals } from '../events'

export default {
  name: 'report-button',
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    ...mapActions(['report']),
    showReportModal() {
      $modals.emit('show', { modal: 'report-post', callback: this.reportPost })
    },
    reportPost(payload) {
      this.report({
        type: 'post',
        id: this.postId,
        reason: payload.reason,
      })
    },
  },
}
</script>

<style lang="sass">
.report-button
  display: inline-block
  margin-bottom: 0.5rem
  font-size: 1rem
  font-variant: all-small-caps

  &.--underline-effect
    --underline-effect-line-height: 2px
</style>
